export default {
    light: {
        themeRootClass: 'theme-light',
        light: true,
        dark: false,
        primaryBg: "blue accent-4",
        toolbarBg: "blue-grey darken-5",
        toolbarText: "blue--text text--lighten-2",
	    navbarBg: "blue accent-4",
        baseBg: "grey lighten-5",
        contentBg: "white",
        toolbarItemActive: "black--text",
        toolbarItemDisabled: "grey--text",
        toolbarItemDefault: "grey--text text--darken-1",
        toolbarItemSpanActive: "black--text",
        toolbarItemSpanDefault: "grey--text text--darken-1",
        baseText: "blackText",
        defaultText: "",
        jawRegionMarkerBg: "grey lighten-2",
        featuredText: "pink--text",
    },
    dark: {
        themeRootClass: 'theme-dark',
        light: false,
        dark: true,
        primaryBg: "blue darken-4",
	    navbarBg: "blue darken-4",
        baseBg: "blue-grey darken-4",
        contentBg: "grey darken-4",
        toolbarItemActive: "blue--text text--darken-3",
        toolbarItemDisabled: "grey--text",
        toolbarItemDefault: "white--text",
        toolbarItemSpanActive: "blue--text text--lighten-2",
        toolbarItemSpanDefault: "white--text",
        baseText: "grey--text text--lighten-3",
        defaultText: "grey--text text--lighten-3",
        jawRegionMarkerBg: "grey darken-2",
        featuredText: "white--text",
    },
};
